import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CloseButtonComponent } from '../../../atoms/close-button/close-button.component';
import { ModalService } from '../../../../services/modal.service';
import { IconComponent } from '../../../atoms/icon/icon.component';

@Component({
  selector: 'app-modal-header',
  imports: [CloseButtonComponent, IconComponent],
  templateUrl: './modal-header.component.html',
  styleUrl: './modal-header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHeaderComponent {
  readonly title = input.required<string>();
  readonly iconPath = input<string | null>(null);

  private readonly modalService = inject(ModalService);

  onClose(): void {
    this.modalService.close();
  }
}
